/**
 * Cleans `__typename` fields out of a ${@link ChargebeePortalSession}. It seems that Chargebee
 * doesn't accept objects with unknown keys like `__typename`, so this is a precaution to avoid any
 * issues caused by a schema mismatch.
 * */
export const cleanPortalSessionData = (
    portalSession: ChargebeePortalSession,
): ChargebeePortalSession => {
    // I'm copying properties over to a fresh object because Apollo uses immutable types
    // - so we can't just use `delete` to delete `__typename`.
    const {
        id,
        token,
        access_url,
        status,
        created_at,
        expires_at,
        object,
        customer_id,
        redirect_url,
    } = portalSession;

    const linkedCustomers = portalSession.linked_customers ?? [];

    const cleanedLinkedCustomers = linkedCustomers.reduce(
        (
            acc: ChargebeeLinkedCustomer[],
            curr: Maybe<ChargebeeLinkedCustomer>,
        ): ChargebeeLinkedCustomer[] => {
            if (curr !== null) {
                acc.push({
                    object: curr.object,
                    customer_id: curr.customer_id,
                    email: curr.email,
                    has_billing_address: curr.has_billing_address,
                    has_active_subscription: curr.has_active_subscription,
                });
            }

            return acc;
        },
        [],
    );

    return {
        id,
        token,
        access_url,
        status,
        created_at,
        expires_at,
        object,
        customer_id,
        redirect_url,
        linked_customers: cleanedLinkedCustomers,
    };
};
